import { SHARED_STEPS } from './shared.steps';
import { backButton, nextButton, finishButton } from '../tourButtons';

export function getAdminSteps(t) {
  return [
    SHARED_STEPS.welcome(t),
    SHARED_STEPS.sidebar(t),

    {
      id: 'dashboard-kpi',
      attachTo: { element: '[data-tour="kpi-cards"]', on: 'bottom' },
      title: t('tour.kpi.title'),
      text: t('tour.kpi.text'),
      buttons: [backButton(t), nextButton(t)],
    },

    {
      id: 'tenants',
      attachTo: { element: '[data-tour="nav-admin.tenants"]', on: 'right' },
      title: t('tour.tenants.title'),
      text: t('tour.tenants.text'),
      buttons: [backButton(t), nextButton(t)],
    },

    {
      id: 'users',
      attachTo: { element: '[data-tour="nav-admin.users"]', on: 'right' },
      title: t('tour.users.title'),
      text: t('tour.users.text'),
      buttons: [backButton(t), nextButton(t)],
    },

    {
      id: 'stations',
      attachTo: { element: '[data-tour="nav-admin.stations"]', on: 'right' },
      title: t('tour.devices.title'),
      text: t('tour.devices.text'),
      buttons: [backButton(t), nextButton(t)],
    },

    {
      id: 'audit-log',
      attachTo: { element: '[data-tour="nav-admin.auditLog"]', on: 'right' },
      title: t('tour.auditLog.title'),
      text: t('tour.auditLog.text'),
      buttons: [backButton(t), nextButton(t)],
    },

    {
      id: 'admin-settings',
      attachTo: { element: '[data-tour="nav-admin.settings"]', on: 'right' },
      title: t('tour.adminSettings.title'),
      text: t('tour.adminSettings.text'),
      buttons: [backButton(t), nextButton(t)],
    },

    {
      id: 'admin-help',
      attachTo: { element: '[data-tour="nav-admin.helpCenter"]', on: 'right' },
      title: t('tour.help.title'),
      text: t('tour.help.text'),
      buttons: [backButton(t), finishButton(t)],
    },
  ];
}
